import { supabaseClient } from '../net/supabase-client.js?v=20260801-token-hash-1';

const ALLOWED_EVENTS = new Set([
  'session_start', 'daily_claimed', 'quest_claimed', 'pass_tier_claimed',
  'checkout_started', 'premium_purchase', 'economy_snapshot',
]);

let enabled = false;
let flushTimer = null;
let snapshotTimer = null;
let snapshotProvider = null;
let queue = [];
const sessionId = crypto.randomUUID();

function safeProperties(properties) {
  const value = properties && typeof properties === 'object' && !Array.isArray(properties) ? properties : {};
  try {
    const encoded = JSON.stringify(value);
    return JSON.parse(encoded.length <= 4000 ? encoded : '{}');
  } catch {
    return {};
  }
}

export function trackEvent(eventName, properties = {}) {
  if (!enabled || !ALLOWED_EVENTS.has(eventName)) return;
  queue.push({
    event_name: eventName,
    session_id: sessionId,
    occurred_at: new Date().toISOString(),
    properties: safeProperties(properties),
  });
  if (queue.length >= 20) flushTelemetry().catch(() => {});
}

export async function flushTelemetry() {
  if (!enabled || !queue.length) return 0;
  const batch = queue.splice(0, 50);
  const { data, error } = await supabaseClient.rpc('record_gameplay_events', { p_events: batch });
  if (error) {
    queue = [...batch, ...queue].slice(-100);
    throw error;
  }
  return Number(data) || batch.length;
}

export function initTelemetry({ snapshot = null } = {}) {
  enabled = true;
  snapshotProvider = typeof snapshot === 'function' ? snapshot : null;
  clearInterval(flushTimer);
  clearInterval(snapshotTimer);
  flushTimer = setInterval(() => flushTelemetry().catch(() => {}), 30000);
  snapshotTimer = setInterval(() => {
    if (snapshotProvider) trackEvent('economy_snapshot', snapshotProvider());
  }, 30 * 60000);
  addEventListener('pagehide', () => flushTelemetry().catch(() => {}), { once: true });
  trackEvent('session_start', {});
  if (snapshotProvider) trackEvent('economy_snapshot', snapshotProvider());
}
